export default function PrevailContent() {
  return (
    <>
      <h2>Why this template exists</h2>
      <p>
        Prevail! is a lightweight action-tracking board with GTD-adjacent
        DNA. The{" "}
        <a
          href="https://gettingthingsdone.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          David Allen
        </a>{" "}
        "capture everything, then process it" instinct, stripped down to
        six columns that fit on one screen. It's the shape of workflow you
        invent when a full project-management tool feels like carrying a
        suitcase for a walk to the corner store.
      </p>

      <blockquote>
        Your mind is for having ideas, not holding them.
        <br />
        <em>&mdash; David Allen, Getting Things Done</em>
      </blockquote>

      <h2>When to use this template</h2>
      <p>
        Personal action tracking, tiny-team weekly planning, side projects,
        household projects big enough to need a board but too small to
        justify Asana. The "Don't Do" column is the underrated one; it's
        where you park items you've decided not to pursue, so you don't
        keep re-thinking them every time your brain surfaces the thought.
        Retroboard's persistent polls pair well here for tracking which
        items in Done delivered the most value over time.
      </p>

      <h2>Not the right shape for</h2>
      <p>
        Multi-team engineering work with dependencies, sprints, or
        stakeholders who need visibility. If your list-management needs
        include the word "roadmap," use a real PM tool. Prevail is a
        personal-productivity board that happens to be shareable, not a
        Jira replacement.
      </p>

      <h2>How to run it</h2>
      <p>
        Capture everything into To Do without judging it first; the editing
        happens later. Once a week, walk the board: promote items to Do
        Next, hand things off to Delegate, park what's blocked in Follow
        Up, and move genuine "not this quarter" items to Don't Do. The
        weekly walk is the whole practice.
      </p>

      <h2>Common pitfalls</h2>
      <p>
        People skip the Don't Do column and let items rot in To Do
        forever. That's how a to-do list becomes a source of guilt
        instead of a source of leverage. Being honest that you're not
        going to write that blog post is a productivity gain, not a
        failure.
      </p>
    </>
  )
}
